
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter_warning)"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"8","fill":"#F9C22E"}})]),_c('path',{attrs:{"d":"M11.11 12.28a.28.28 0 01-.18-.06.22.22 0 01-.06-.17l-.25-5.33c0-.14.07-.22.2-.22h2.38c.14 0 .2.08.2.22l-.26 5.33a.2.2 0 01-.08.17.22.22 0 01-.16.06h-1.8zM11.9 17c-.4 0-.75-.13-1.02-.39a1.41 1.41 0 01-.39-1.02c0-.42.13-.76.4-1.02.26-.26.6-.39 1.01-.39a1.36 1.36 0 011.41 1.41c0 .4-.13.73-.4 1-.26.27-.6.41-1 .41z","fill":"#251F1C"}}),_c('defs',[_c('filter',{attrs:{"id":"filter_warning","x":"0","y":"0","width":"24","height":"24","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}}),_c('feOffset'),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.976471 0 0 0 0 0.760784 0 0 0 0 0.180392 0 0 0 1 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow","result":"shape"}})])])])
          )
        }
      }
    